// https://vuex.vuejs.org/en/getters.html

import { TypeScanEnum } from '@/modules/Enums'

export default {
  isAuthenticated: state => {
    return state.teleparameters !== null
  },
  isConnected: state => {
    return state.networkType !== Connection.UNKNOWN && state.networkType !== Connection.NONE
  },
  isNotConnected: state => {
    return !IS_DESKTOP && (state.networkType === Connection.UNKNOWN || state.networkType === Connection.NONE)
  },
  favoriteScan: state => {
    return state.favoriteScan !== null ? TypeScanEnum[state.favoriteScan].view : null
  },
  // ***** PARAMETRES *****
  currency: state => {
    if (state.teleparameters && state.teleparameters.Currency) {
      return state.teleparameters.Currency
    }
    return {
      Devise: 'EUR',
      Symbole: '€',
      Decimales: 2
    }
  },
  creditPermissions: state => {
    return state.creditPermissions
  },
  useCashlessTransfer: state => {
    if (state.teleparameters) {
      return state.teleparameters.PME.Debit === 1 ||
        parseInt(state.creditPermissions) !== 0
    }
    return false
  },
  airsafeAuthorization: state => {
    return 0
  },
  contactlessAuthorization: state => {
    if (state.teleparameters) {
      return state.teleparameters.SansContact
    }
    return 0
  },
  vchAuthorization: state => {
    if (state.teleparameters) {
      return state.teleparameters.VCH
    }
    return 0
  },
  isMarketPlace: state => {
    if (state.teleparameters) {
      return state.teleparameters.AvecMarketPlace
    }
    return 0
  },
  giftAuthorization: state => {
    if (state.teleparameters) {
      return state.teleparameters.KDO
    }
    return 0
  },
  cashlessAuthorization: state => {
    if (state.teleparameters) {
      return state.teleparameters.PME
    }
    return null
  },
  chequeDebitAccept: state => {
    return state.teleparameters.KDO.CHQ.Debit === 1
  },
  chequeCreditAccept: state => {
    if (state.teleparameters) {
      return state.teleparameters.KDO.CHQ.Credit !== 0
    }
    return false
  },
  carteDebitAccept: state => {
    return state.teleparameters.KDO.CARTE.Debit === 1
  },
  carteCreditAccept: state => {
    if (state.teleparameters) {
      return state.teleparameters.KDO.CARTE.Credit !== 0
    }
    return false
  },
  masks: state => {
    if (state.teleparameters) {
      return state.teleparameters.masks
    }
    return null
  },
  idEvent: state => {
    if (state.event !== null) {
      return state.event.id
    }
    return 0
  },
  useFid: state => {
    if (state.teleparameters) {
      return state.teleparameters.FID
    }
    return 0
  },
  useVivaWallet: state => {
    if (state.teleparameters) {
      return state.teleparameters.useVivaWallet
    }
    return false
  },
  useSoftPos: state => {
    return !IS_INGENICO && !IS_PAX && !IS_SUNMI && (
      state.teleparameters &&
      state.teleparameters.PaiementService &&
      state.teleparameters.PaiementService.Params &&
      state.teleparameters.PaiementService.Params.keyAlias
    )
  },
  isGiftOnly: state => {
    if (state.teleparameters) {
      return state.teleparameters.isGiftOnly
    }
    return false
  },
  useGiftReset: state => {
    if (state.teleparameters) {
      return state.teleparameters.useGiftReset
    }
    return false
  },
  useInvoicePayment: state => {
    if (state.teleparameters) {
      return state.teleparameters.useInvoicePayment
    }
    return false
  },
  useOnlineRefill: state => {
    if (state.teleparameters) {
      return state.teleparameters.useOnlineRefill
    }
    return false
  },
  isMobil: state => {
    if (state.teleparameters) {
      return state.teleparameters.isMobil
    }
    return false
  },
  postJackpot: state => {
    if (state.teleparameters) {
      return state.teleparameters.postJackpot
    }
    return false
  },
  checkTransaction: state => {
    if (state.teleparameters) {
      return state.teleparameters.checkTransaction
    }
    return false
  },
  questionsMobil: state => {
    if (state.teleparameters) {
      return state.teleparameters.questionsMobil
    }
    return []
  },
  useBanking: (state, getters) => {
    return state.teleparameters && state.teleparameters.useBanking && (
      IS_PAX || IS_INGENICO || IS_SUNMI || (IS_ANDROID && (getters.useVivaWallet || getters.useSoftPos))
    )
  },
  // ***** APPLICATION *****
  productslength: state => {
    return state.listproducts.length
  },
  numberOfProductsInBasket: state => {
    let count = 0
    state.listproducts.forEach(list => {
      list.products.forEach(product => {
        if (product !== null) count += product.quantity
      })
    })

    return count
  },
  totalTransactions: state => {
    return state.transactions.pax +
      state.transactions.donation +
      state.transactions.tips +
      state.transactions.cashless
  },
  numberOfConsignes: state => {
    let count = 0
    state.consignes.forEach(el => {
      count += el.consigne.number
      count += el.deconsigne.number
    })

    return count
  },
  totalNumberOfConsignesAndProducts: (state, getters) => {
    return getters.numberOfConsignes + getters.numberOfProductsInBasket
  },
  paymentService: state => {
    if (state.teleparameters && state.teleparameters.PaiementService) {
      return state.teleparameters.PaiementService.App.toLowerCase()
    }
    return null
  },
  paymentParams: state => {
    if (state.teleparameters && state.teleparameters.PaiementService) {
      return state.teleparameters.PaiementService.Params
    }
    return {}
  },
  boostoreParams: state => {
    if (state.teleparameters && state.teleparameters.BoostoreService) {
      return state.teleparameters.BoostoreService
    }
    return {}
  },
  useW2S: state => {
    if (state.teleparameters && state.teleparameters.RefTransac) {
      return (
        (state.teleparameters.RefTransac.W2SListe === 1 ||
        state.teleparameters.RefTransac.W2SRecherche === 1) &&
        state.amount === 0
      ) || (
        state.teleparameters.RefTransac.Saisie === 1 && state.amount > 0
      )
    }
    return false
  },
  posInfos: state => {
    if (state.teleparameters && state.teleparameters.InfosPDV) {
      return state.teleparameters.InfosPDV
    }
    return {}
  },
  creationContactMyTerminal: state => {
    if (state.teleparameters && state.teleparameters.CreationContactMyTerminal) {
      try {
        const CreationContactMyTerminal = JSON.parse(state.teleparameters.CreationContactMyTerminal)
        return CreationContactMyTerminal ?? []
      } catch (_) {
        return []
      }
    }
    return []
  },
  qrCodeUrl: state => {
    return state.qrCodeUrl
  },
  campaigns: state => {
    if (state.teleparameters && state.teleparameters.Campagnes) {
      return state.teleparameters.Campagnes
    }
    return []
  },
  donationCampaign: (state, getters) => {
    return getters.campaigns.find(campagne => campagne.Type === 0)
  },
  tipCampaign: (state, getters) => {
    return getters.campaigns.find(campagne => campagne.Type === 1)
  },
  campaignDeactivated: state => {
    return state.campaignDeactivated
  },
  posAddress: state => {
    return state.teleparameters.InfosPDV.Adresse
  },
  programmesKDO: state => {
    if (state.teleparameters && state.teleparameters.ProgrammesKDO) {
      return state.teleparameters.ProgrammesKDO
    }
    return []
  },
  enseigne: state => {
    return state.teleparameters.InfosPDV.Enseigne
  },
  externalAction: state => {
    return state.intent.intentAction ? state.intent.intentAction : null
  },
  //
  neptingMerchant: state => {
    return state.neptingInfos.merchantId
  },
  neptingServer: state => {
    return state.neptingInfos.server
  },
  neptingToken: state => {
    return state.neptingInfos.token
  },
}
